import PropTypes from 'prop-types';

export const RULES__CREATE = 'RULES__CREATE';
export const RULES__DELETE = 'RULES__DELETE';
export const RULES__PATCH = 'RULES__PATCH';
export const RULES__REPLACE = 'RULES__REPLACE';
export const RULES__UPDATE = 'RULES__UPDATE';

export const RULE_TYPE__ELEMENT = 'ElementRule';
export const RULE_TYPE__LOCATION = 'LocationRule';
export const RULE_TYPE__PARTICIPANT = 'ParticipantRule';
export const RULE_TYPE__VARIATION = 'VariationRule';

export const RULES__SHAPE_VALUE = PropTypes.oneOfType([
  PropTypes.bool,
  PropTypes.number,
  PropTypes.string,
  PropTypes.arrayOf(PropTypes.string),
  PropTypes.arrayOf(PropTypes.number),
]);

export const RULES__SHAPE_ITEM = PropTypes.shape({
  afterPosition: PropTypes.number,
  conditionId: PropTypes.string,
  createdAt: PropTypes.number,
  elementId: PropTypes.string,
  id: PropTypes.string,
  operator: PropTypes.string,
  value: RULES__SHAPE_VALUE,
});

export const RULES__SHAPE_ARRAY = PropTypes.arrayOf(RULES__SHAPE_ITEM);
